import { render } from "./BFromStationSelect.vue?vue&type=template&id=16ba8693&scoped=true"
import script from "./BFromStationSelect.vue?vue&type=script&lang=js"
export * from "./BFromStationSelect.vue?vue&type=script&lang=js"

import "./BFromStationSelect.vue?vue&type=style&index=0&id=16ba8693&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-16ba8693"

export default script